import styled from '@emotion/styled';
import type { MicrositeResponsiveImage } from '~/model';
import MicrositeResponsiveImg from '~/components/MicrositeResponsiveImg';
import { LoadPriority } from '~/hooks/useLoadPriority';

const Section = styled.section`
	padding: 3rem 1.5rem 4rem;
	background: #f5f5f5;
`;

const Title = styled.h2`
	font-size: 2rem;
	text-transform: uppercase;
	margin-bottom: 2rem;
`;

const Grid = styled.div`
	max-width: 96rem;
	margin: 0 auto;
	display: grid;
	gap: 1.5rem;
`;

export default function FloorplanBlockZeta({ floors }: { floors: MicrositeResponsiveImage[] }) {
	if (floors.length === 0) return null;

	return (
		<Section id="floor_plans">
			<Grid>
				<Title>Floor Plans</Title>
				{floors.map((floor, index) => (
					<div key={index}>
						<MicrositeResponsiveImg image={floor} priority={LoadPriority.FIRST_PAINT} />
					</div>
				))}
			</Grid>
		</Section>
	);
}
